// navbar scroll
$(document).ready(function () {
    $(window).scroll(function () {
      var header = $(".innerHeader");
      if ($(window).scrollTop() > 0) {
        header.css("margin-top", "unset");
      } else {
        header.css("margin-top", "20px");
      }
    });
  });

  // nav bar hamburger
$(document).ready(function () {
    $(".hamburger button").click(function () {
      $(this).toggleClass("active");
      $("#navbar").toggleClass("active");
      if ($(this).hasClass("active")) {
        $("html").addClass("overflow");
      } else {
        $("html").removeClass("overflow");
      }
    });
  });



//faqs

$(document).ready(function () {
  $(".QA-content:first .answer").slideDown();
  $(".QA-content:first").addClass("answer-active");
  $(".QA-content:first .Question").addClass("question-active");

  $(".Question").click(function () {
      var $qaContent = $(this).closest(".QA-content");
      var $answer = $qaContent.find(".answer");
    
      $(".answer").not($answer).slideUp();
      $(".QA-content").not($qaContent).removeClass("answer-active");
      
      $answer.slideToggle();
      
      $qaContent.toggleClass("answer-active");
      
      $(this).toggleClass("question-active");

      $(".Question").not(this).removeClass("question-active");
  });
});


//testimonial slider

$(document).ready(function () {
  var slider = $(".testimonial-slider");

  slider.slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".next").on("click", function () {
    slider.slick("slickPrev");
  });
  
  $(".prev").on("click", function () {
    slider.slick("slickNext");
  });
});

//smart slider
$(document).ready(function () {
  var slider = $(".smart-slider");

  slider.slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
     
    ],
  });
 
});

//image slider
$(document).ready(function () {
  var slider = $(".image-slider");

  slider.slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
     
    ],
  });
 $(".img-next").on("click", function () {
    slider.slick("slickNext");
  });
  
  $(".img-prev").on("click", function () {
    slider.slick("slickPrev");
  });
});

//fancy box scroll

   $(document).ready(function () {
            // Function to disable scrolling on body
            function disableScroll() {
                $('html').addClass('stop-scrolling');
            }

            // Function to enable scrolling on body
            function enableScroll() {
                $('html').removeClass('stop-scrolling');
            }

            // Initialize FancyBox
            $('[data-fancybox]').fancybox({
                beforeShow: disableScroll, // Call disableScroll function before opening FancyBox
                afterClose: enableScroll // Call enableScroll function after closing FancyBox
            });
        });


//popup

$(document).ready(function(){
  $(".popup-open").click(function(){
      $("html").addClass("overflow-hidden");
      $(".parent-pop").css('display', 'flex');
  });

  

  $(".popup-close").click(function(){
      $("html").removeClass("overflow-hidden");
      $(".parent-pop").hide();
  });


  $(".parent-pop").hide();

  if(window.location.href.indexOf("contact_posted=true") > -1) {
        // If the string is found, execute the code
        $(".parent-pop").css('display', 'flex');
    }
});